import { action, computed } from 'mobx';
import Alert from 'react-s-alert';

import { AppManager, Variables, Input } from 'core/index';
import { routerStore } from 'core/routing';

import { raiseUserError } from 'apps/utils';

import { clientStore } from 'apps/client/app';
import { InviteLinkApp, InviteLinkModel } from 'apps/group/app';
import { InviteQuery, AcceptInvite } from 'apps/group/gql';

export class InviteAppManager extends AppManager {
  static registryName = 'InviteAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('invite', InviteLinkApp);
    this.variables = new Variables({
      token: () => this.params.get('token'),
      inviteLinkId: () => this.params.get('inviteId'),
      referrerUserId: () => this.params.get('referrerUserId'),
    });
    this.variables.onChange(
      ['token', 'inviteLinkId', 'referrerUserId'],
      this.NewParams,
    );
  }

  @computed
  get loading() {
    return this.queries.get('invite')?.loading;
  }

  @action
  NewParams = () => {
    this.NewInviteQuery();
  };

  @action
  NewInviteQuery = () => {
    const q = new InviteQuery(this, {
      queryKey: 'invite',
      onSysErr: this.onError,
    });
    q.process(invite => InviteLinkModel.Load(invite), this.InviteUpdate);
    q.query();
  };

  @action
  InviteUpdate = invModel => {
    this.invite = invModel;
  };

  @action
  Accept = () => {
    const input = new Input({
      inviteId: this.variables.inviteLinkId,
      referrerUserId: this.variables.referrerUserId,
      token: this.variables.token,
    });
    this.mutations.push(
      AcceptInvite.New(input, {
        onSysErr: this.OnInviteError,
        onUserErr: this.OnInviteError,
        onSuccess: this.OnInviteSuccess.bind(this),
      }),
    );
  };

  @action
  OnInviteError = error => {
    raiseUserError(error, 'accept', 'Invite');
  };

  async OnInviteSuccess() {
    await clientStore.WhoAmI();
    const targetRoute = this.invite.route;
    routerStore.navigate(targetRoute.name, targetRoute.params);
    Alert.success(`Joined ${this.invite.content.title} successfully.`);
  }

  @action
  Reject = () => {
    routerStore.navigate('home');
  };
}
